// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_bbo","cls2":"Accordion-cls2_idV Accordion-cls1_bbo"};